export const AUTH_REDIRECT_DELAY = 1500;
